import React from 'react';
import { Route, Switch } from 'react-router-dom';

import { ROUTES } from '@common/constants';

import './houseTypes.less';
import CreateHouseTypes from './pages/CreateHouseTypes';
import HouseTypes from './pages/HouseTypes';

const HouseTypesWrapper = () => (
  <>
    <Switch>
      <Route
        exact
        path={`${ROUTES?.MASTER}${ROUTES?.HOUSE_TYPES}`}
        render={(props) => <HouseTypes {...props} />}
      />
      <Route
        exact
        path={`${ROUTES?.MASTER}${ROUTES?.HOUSE_TYPES}/add`}
        render={(props) => <CreateHouseTypes {...props} />}
      />
      <Route
        exact
        path={`${ROUTES?.MASTER}${ROUTES?.HOUSE_TYPES}/:mode/:id`}
        render={(props) => <CreateHouseTypes {...props} />}
      />
    </Switch>
  </>
);

export default HouseTypesWrapper;
